import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

export const socialLinks = [
  {
    name: 'youtube',
    url: 'https://www.youtube.com/webcifarOfficial',
    icon: <FaYoutube />,
  },
  {
    name: 'instagram',
    url: 'https://www.youtube.com/web_cifar',
    icon: <FaInstagram />,
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/webcifar',
    icon: <FaFacebook />,
  },
  {
    name: 'twitter',
    url: 'https://www.twitter.com/webcifar',
    icon: <FaTwitter />,
  },
];
